var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMembershipAdIcon = function SvgMembershipAdIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4193 23.6792H5.43545C5.43545 23.6792 5.80919 33.5194 4.09971 37.1349C3.92675 37.5006 4.19136 37.9206 4.59886 37.9206H8.25597C8.66346 37.9206 8.928 37.5006 8.75511 37.1349C7.04556 33.5193 7.4193 23.6792 7.4193 23.6792Z",
    fill: "url(#paint0_linear_1742_80162)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24859 35.6804C7.78866 33.9287 7.56635 31.5986 7.4642 29.457H5.39035C5.28827 31.5986 5.06588 33.9287 4.60596 35.6804H8.24859Z",
    fill: "url(#paint1_linear_1742_80162)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.09971 37.1352C3.92675 37.5009 4.19136 37.921 4.59886 37.921H8.25597C8.66346 37.921 8.928 37.5009 8.75511 37.1352C8.56041 36.7234 8.393 36.2302 8.24869 35.6807H4.60614C4.46183 36.2303 4.29442 36.7234 4.09971 37.1352Z",
    fill: "url(#paint2_linear_1742_80162)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4807 29.2912C11.4807 32.0581 9.21817 34.3011 6.42713 34.3011C3.6361 34.3011 1.37354 32.0581 1.37354 29.2912C1.37354 26.5243 3.6361 4.9707 6.42713 4.9707C9.21817 4.9707 11.4807 26.5243 11.4807 29.2912Z",
    fill: "url(#paint3_linear_1742_80162)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4807 29.2912C11.4807 32.0581 9.21817 34.3011 6.42713 34.3011C3.6361 34.3011 1.37354 32.0581 1.37354 29.2912C1.37354 26.5243 3.6361 4.9707 6.42713 4.9707C9.21817 4.9707 11.4807 26.5243 11.4807 29.2912Z",
    fill: "url(#paint4_linear_1742_80162)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M1.37354 29.291C1.37354 32.0579 3.6361 34.3009 6.42713 34.3009C9.21817 34.3009 11.4807 32.0579 11.4807 29.291C11.4807 29.0158 11.4582 28.5541 11.4152 27.9468H1.43909C1.39596 28.5541 1.37354 29.0158 1.37354 29.291Z",
    fill: "url(#paint5_linear_1742_80162)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59564 28.9938C2.67669 29.0509 1.97826 29.8355 2.03578 30.7466C2.04733 30.9299 2.20657 31.0691 2.39145 31.0576C3.3104 31.0007 4.00883 30.2159 3.9513 29.3049C3.93975 29.1216 3.78052 28.9823 3.59564 28.9938Z",
    fill: "url(#paint6_linear_1742_80162)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.71145 27.7177C5.53152 27.7611 5.42111 27.941 5.46491 28.1194C5.68272 29.0063 6.58457 29.5502 7.47921 29.3342C7.65915 29.2908 7.76955 29.111 7.72575 28.9326C7.50794 28.0457 6.60609 27.5018 5.71145 27.7177Z",
    fill: "url(#paint7_linear_1742_80162)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.04168 22.0319C4.12274 22.0889 3.4243 22.8736 3.48183 23.7847C3.49338 23.968 3.65261 24.1072 3.8375 24.0957C4.75644 24.0387 5.45488 23.254 5.39735 22.3429C5.38572 22.1597 5.22657 22.0205 5.04168 22.0319Z",
    fill: "url(#paint8_linear_1742_80162)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.31954 16.8444C7.22721 16.6853 7.02215 16.6305 6.86164 16.7221C6.06353 17.1773 5.78887 18.1877 6.24804 18.9789C6.34044 19.1381 6.54543 19.1929 6.70594 19.1013C7.50405 18.6461 7.77879 17.6357 7.31954 16.8444Z",
    fill: "url(#paint9_linear_1742_80162)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6811 25.4973C9.93036 24.9687 8.88961 25.1436 8.35641 25.8877C8.24915 26.0374 8.28463 26.245 8.43561 26.3513C9.18632 26.8799 10.2271 26.705 10.7603 25.9608C10.8675 25.8112 10.8321 25.6036 10.6811 25.4973Z",
    fill: "url(#paint10_linear_1742_80162)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9055 24.6097C10.0905 24.5999 10.2324 24.4433 10.2225 24.2599C10.1733 23.3484 9.38805 22.649 8.46858 22.6977C8.28362 22.7075 8.14171 22.8641 8.15161 23.0475C8.20081 23.959 8.98603 24.6584 9.9055 24.6097Z",
    fill: "url(#paint11_linear_1742_80162)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M6.06526 11.8354C5.8803 11.8452 5.73839 12.0018 5.74829 12.1852C5.79749 13.0967 6.58271 13.7961 7.5021 13.7474C7.68706 13.7375 7.82897 13.581 7.81907 13.3976C7.76994 12.4861 6.98473 11.7867 6.06526 11.8354Z",
    fill: "url(#paint12_linear_1742_80162)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3039 22.3022H20.1282C20.1282 22.3022 20.5381 33.0939 18.6633 37.0591C18.4736 37.4602 18.7638 37.9208 19.2106 37.9208H23.2214C23.6683 37.9208 23.9585 37.4601 23.7688 37.0591C21.894 33.0939 22.3039 22.3022 22.3039 22.3022Z",
    fill: "url(#paint13_linear_1742_80162)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2136 35.4644C22.7092 33.5433 22.4654 30.9879 22.3534 28.6392H20.079C19.967 30.9878 19.7231 33.5432 19.2188 35.4644H23.2136Z",
    fill: "url(#paint14_linear_1742_80162)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6633 37.059C18.4736 37.4601 18.7638 37.9207 19.2106 37.9207H23.2214C23.6683 37.9207 23.9585 37.4601 23.7688 37.059C23.5552 36.6074 23.3716 36.0665 23.2134 35.4639H19.2187C19.0603 36.0665 18.8768 36.6074 18.6633 37.059Z",
    fill: "url(#paint15_linear_1742_80162)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7581 28.457C26.7581 31.4914 24.2767 33.9513 21.2158 33.9513C18.1549 33.9513 15.6736 31.4914 15.6736 28.457C15.6736 25.4226 18.1549 1.78467 21.2158 1.78467C24.2767 1.78467 26.7581 25.4226 26.7581 28.457Z",
    fill: "url(#paint16_linear_1742_80162)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7581 28.457C26.7581 31.4914 24.2767 33.9513 21.2158 33.9513C18.1549 33.9513 15.6736 31.4914 15.6736 28.457C15.6736 25.4226 18.1549 1.78467 21.2158 1.78467C24.2767 1.78467 26.7581 25.4226 26.7581 28.457Z",
    fill: "url(#paint17_linear_1742_80162)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6736 28.4567C15.6736 31.4911 18.1549 33.9509 21.2158 33.9509C24.2767 33.9509 26.7581 31.4911 26.7581 28.4567C26.7581 28.1548 26.7335 27.6485 26.6862 26.9824H15.7454C15.6983 27.6485 15.6736 28.1548 15.6736 28.4567Z",
    fill: "url(#paint18_linear_1742_80162)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1108 28.1306C17.103 28.1931 16.337 29.0537 16.4001 30.0528C16.4128 30.2538 16.5874 30.4065 16.7901 30.394C17.798 30.3314 18.5639 29.4708 18.5008 28.4717C18.4881 28.2708 18.3135 28.118 18.1108 28.1306Z",
    fill: "url(#paint19_linear_1742_80162)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M20.431 26.7311C20.2337 26.7787 20.1126 26.9759 20.1607 27.1715C20.3996 28.1442 21.3886 28.7407 22.3698 28.5039C22.5671 28.4562 22.6882 28.2591 22.6401 28.0634C22.4012 27.0908 21.4122 26.4942 20.431 26.7311Z",
    fill: "url(#paint20_linear_1742_80162)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6967 20.4954C18.6889 20.5579 17.923 21.4185 17.9861 22.4176C17.9987 22.6186 18.1733 22.7713 18.3761 22.7587C19.3839 22.6962 20.1498 21.8356 20.0868 20.8365C20.0741 20.6355 19.8995 20.4828 19.6967 20.4954Z",
    fill: "url(#paint21_linear_1742_80162)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1947 14.8064C22.0934 14.6318 21.8686 14.5718 21.6925 14.6721C20.8172 15.1714 20.516 16.2795 21.0195 17.1473C21.1209 17.3218 21.3457 17.3819 21.5218 17.2815C22.3971 16.7822 22.6984 15.6741 22.1947 14.8064Z",
    fill: "url(#paint22_linear_1742_80162)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8813 24.2964C25.058 23.7167 23.9166 23.9085 23.3319 24.7246C23.2143 24.8887 23.2532 25.1163 23.4188 25.2329C24.2421 25.8126 25.3835 25.6208 25.9682 24.8047C26.0858 24.6406 26.0469 24.4129 25.8813 24.2964Z",
    fill: "url(#paint23_linear_1742_80162)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0307 23.322C25.2335 23.3112 25.3891 23.1396 25.3783 22.9385C25.3244 21.9389 24.4632 21.1718 23.4549 21.2253C23.2521 21.2361 23.0964 21.4078 23.1072 21.6088C23.1611 22.6084 24.0223 23.3755 25.0307 23.322Z",
    fill: "url(#paint24_linear_1742_80162)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8191 9.31269C20.6163 9.32347 20.4607 9.49516 20.4715 9.69621C20.5254 10.6958 21.3865 11.4629 22.3949 11.4094C22.5978 11.3987 22.7534 11.227 22.7426 11.0259C22.6887 10.0263 21.8275 9.25923 20.8191 9.31269Z",
    fill: "url(#paint25_linear_1742_80162)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2163 1.78467C20.6271 1.78467 20.0574 2.51067 19.5185 3.72436C18.8259 5.28432 18.4851 6.97545 18.4851 8.67988V10.2479C18.4851 10.81 18.9151 11.2957 19.4809 11.333C19.8053 11.3543 20.1006 11.232 20.3099 11.0254C20.5035 10.8336 20.6227 10.5681 20.6227 10.2759V9.54277C20.6227 8.78881 21.3135 8.21851 22.0613 8.35755C22.068 8.35904 22.0755 8.36052 22.0823 8.36201C22.4746 8.43414 22.7596 8.77245 22.7596 9.16802V9.29516C22.7596 9.41331 22.7791 9.52685 22.8152 9.63288C23.1428 10.5951 23.2635 11.6148 23.2635 12.6303V16.3953C23.2635 16.9598 23.7012 17.4456 24.2699 17.4721C24.8772 17.5004 25.3785 17.0207 25.3785 16.4249C25.3785 14.0053 25.1151 11.5918 24.5767 9.23181C23.6137 5.01055 22.4584 1.78467 21.2163 1.78467Z",
    fill: "url(#paint26_linear_1742_80162)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M6.42706 4.9707C4.48596 4.9707 2.77798 13.6382 1.78808 20.686C1.7358 21.0583 2.02629 21.4008 2.40529 21.3922C2.41106 21.392 2.41684 21.3919 2.42261 21.3916C2.96781 21.3702 3.38986 20.9067 3.38986 20.3658V16.9113C3.38986 16.5985 3.63302 16.3257 3.94841 16.3163C4.27475 16.3066 4.54244 16.566 4.54244 16.8874V18.3265C4.54244 18.8647 4.95961 19.3278 5.50189 19.3531C6.08084 19.3801 6.55884 18.9228 6.55884 18.3547V16.5462C6.55884 15.9722 7.03054 15.5074 7.61062 15.512C7.82678 15.5138 7.99966 15.6918 7.99966 15.9061V16.8401C7.99966 17.3783 8.41683 17.8414 8.95911 17.8666C9.53806 17.8936 10.0161 17.4363 10.0161 16.8683V15.7138C10.0161 14.715 9.90933 13.7188 9.70165 12.7414C8.7842 8.42292 7.65202 4.9707 6.42706 4.9707Z",
    fill: "url(#paint27_linear_1742_80162)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M15.208 21.5308H12.9249C12.9249 21.5308 13.355 32.8554 11.3876 37.0162C11.1886 37.4372 11.4931 37.9205 11.9621 37.9205H16.1709C16.6398 37.9205 16.9443 37.4372 16.7454 37.0162C14.7779 32.8554 15.208 21.5308 15.208 21.5308Z",
    fill: "url(#paint28_linear_1742_80162)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1622 35.3425C15.6329 33.3265 15.377 30.6448 15.2596 28.1802H12.8729C12.7554 30.6448 12.4995 33.3264 11.9702 35.3425H16.1622Z",
    fill: "url(#paint29_linear_1742_80162)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3874 37.0167C11.1883 37.4376 11.4928 37.921 11.9618 37.921H16.1706C16.6395 37.921 16.944 37.4376 16.745 37.0167C16.521 36.5428 16.3283 35.9752 16.1623 35.3428H11.9702C11.8041 35.9752 11.6115 36.5429 11.3874 37.0167Z",
    fill: "url(#paint30_linear_1742_80162)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8819 27.9895C19.8819 31.1738 17.278 33.7551 14.0659 33.7551C10.8539 33.7551 8.25 31.1737 8.25 27.9895C8.25 24.8053 10.8538 0 14.0659 0C17.278 0 19.8819 24.8052 19.8819 27.9895Z",
    fill: "url(#paint31_linear_1742_80162)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 27.9894C8.25 31.1737 10.8539 33.755 14.0659 33.755C17.278 33.755 19.8819 31.1736 19.8819 27.9894C19.8819 27.6727 19.856 27.1413 19.8064 26.4424H8.32538C8.2758 27.1413 8.25 27.6726 8.25 27.9894Z",
    fill: "url(#paint32_linear_1742_80162)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8073 27.6472C9.74969 27.7128 8.94596 28.6159 9.01211 29.6644C9.02538 29.8753 9.20869 30.0356 9.4214 30.0224C10.479 29.9568 11.2828 29.0537 11.2166 28.0052C11.2033 27.7943 11.02 27.6341 10.8073 27.6472Z",
    fill: "url(#paint33_linear_1742_80162)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2422 26.1784C13.0352 26.2284 12.9081 26.4354 12.9586 26.6407C13.2092 27.6614 14.2471 28.2874 15.2767 28.0389C15.4838 27.9889 15.6109 27.7819 15.5604 27.5766C15.3097 26.5559 14.2718 25.93 13.2422 26.1784Z",
    fill: "url(#paint34_linear_1742_80162)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4714 19.635C11.4138 19.7006 10.61 20.6037 10.6762 21.6522C10.6894 21.8631 10.8728 22.0234 11.0855 22.0102C12.1431 21.9446 12.9468 21.0415 12.8807 19.993C12.8673 19.7821 12.6841 19.6218 12.4714 19.635Z",
    fill: "url(#paint35_linear_1742_80162)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0926 13.6655C14.9863 13.4823 14.7504 13.4193 14.5656 13.5247C13.6471 14.0486 13.331 15.2115 13.8595 16.1219C13.9658 16.3051 14.2017 16.3681 14.3865 16.2628C15.305 15.7389 15.6212 14.576 15.0926 13.6655Z",
    fill: "url(#paint36_linear_1742_80162)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9615 23.6235C18.0975 23.0152 16.8997 23.2164 16.2862 24.0729C16.1627 24.2451 16.2036 24.484 16.3774 24.6063C17.2413 25.2146 18.4391 25.0134 19.0527 24.1569C19.1761 23.9846 19.1353 23.7458 18.9615 23.6235Z",
    fill: "url(#paint37_linear_1742_80162)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0688 22.6015C18.2816 22.5902 18.4449 22.41 18.4336 22.199C18.377 21.15 17.4733 20.3451 16.4152 20.4012C16.2023 20.4125 16.039 20.5927 16.0504 20.8037C16.1069 21.8527 17.0106 22.6576 18.0688 22.6015Z",
    fill: "url(#paint38_linear_1742_80162)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6493 7.90022C13.4364 7.91152 13.2732 8.09168 13.2845 8.3027C13.341 9.3517 14.2448 10.1567 15.3029 10.1005C15.5158 10.0892 15.6791 9.90906 15.6677 9.69804C15.6112 8.64905 14.7075 7.84416 13.6493 7.90022Z",
    fill: "url(#paint39_linear_1742_80162)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2953 16.0852C18.2192 16.0852 18.1442 16.0675 18.0757 16.0347C17.8951 15.9482 17.6915 15.9091 17.4787 15.9305C17.472 15.9312 17.466 15.932 17.4592 15.9327C17.0812 15.9706 16.7917 16.306 16.7917 16.7097C16.7917 17.2942 16.3454 17.7685 15.7956 17.7685C15.2459 17.7685 14.7996 17.2942 14.7996 16.7097V16.5826C14.7996 16.187 14.5348 15.848 14.1688 15.7758C14.1628 15.7744 14.156 15.7736 14.1493 15.7721C13.4518 15.6331 12.8082 16.2026 12.8082 16.9573V17.6905C12.8082 18.2749 12.3627 18.7493 11.8122 18.7493C11.2624 18.7493 10.8169 18.2749 10.8169 17.6897V15.7907C10.8169 15.2479 10.4276 14.7951 9.91909 14.746L9.89659 14.7438C9.89509 14.7431 9.89359 14.7431 9.89134 14.7431C9.65958 14.7222 9.48782 14.5207 9.52382 14.2917C10.6376 7.1678 12.26 0 14.066 0C15.9757 0 17.6793 8.01157 18.7949 15.5128C18.8398 15.8147 18.603 16.0852 18.2953 16.0852Z",
    fill: "url(#paint40_linear_1742_80162)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M8.54278 34.919C9.55745 34.919 10.38 34.1036 10.38 33.0977C10.38 32.0918 9.55745 31.2764 8.54278 31.2764C7.52812 31.2764 6.70557 32.0918 6.70557 33.0977C6.70557 34.1036 7.52812 34.919 8.54278 34.919Z",
    fill: "url(#paint41_linear_1742_80162)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1642 19.4109C16.7425 19.4109 17.2113 18.9462 17.2113 18.373C17.2113 17.7997 16.7425 17.335 16.1642 17.335C15.586 17.335 15.1172 17.7997 15.1172 18.373C15.1172 18.9462 15.586 19.4109 16.1642 19.4109Z",
    fill: "url(#paint42_linear_1742_80162)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M6.08147 2.07598C6.65975 2.07598 7.12853 1.61126 7.12853 1.03799C7.12853 0.464725 6.65975 0 6.08147 0C5.5032 0 5.03442 0.464725 5.03442 1.03799C5.03442 1.61126 5.5032 2.07598 6.08147 2.07598Z",
    fill: "url(#paint43_linear_1742_80162)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M1.83904 17.3939C2.41731 17.3939 2.8861 16.9291 2.8861 16.3559C2.8861 15.7826 2.41731 15.3179 1.83904 15.3179C1.26077 15.3179 0.791992 15.7826 0.791992 16.3559C0.791992 16.9291 1.26077 17.3939 1.83904 17.3939Z",
    fill: "url(#paint44_linear_1742_80162)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9396 29.139C4.8099 29.139 5.51543 28.4396 5.51543 27.5768C5.51543 26.7141 4.8099 26.0146 3.9396 26.0146C3.06929 26.0146 2.36377 26.7141 2.36377 27.5768C2.36377 28.4396 3.06929 29.139 3.9396 29.139Z",
    fill: "url(#paint45_linear_1742_80162)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3158 36.7922C26.3015 35.9705 22.7888 35.4263 18.792 35.4263C14.7951 35.4263 11.2824 35.9705 9.26816 36.7922C8.40804 37.1431 8.7887 37.9999 9.80651 37.9999H27.7775C28.7953 37.9999 29.1759 37.1431 28.3158 36.7922Z",
    fill: "url(#paint46_linear_1742_80162)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3158 36.7922C26.3015 35.9705 22.7888 35.4263 18.792 35.4263C14.7951 35.4263 11.2824 35.9705 9.26816 36.7922C8.40804 37.1431 8.7887 37.9999 9.80651 37.9999H27.7775C28.7953 37.9999 29.1759 37.1431 28.3158 36.7922Z",
    fill: "url(#paint47_linear_1742_80162)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1742_80162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.9923 33.4611C31.9923 36.6222 29.4165 37.832 26.239 37.832C23.0614 37.832 20.4856 36.6222 20.4856 33.4611C20.4856 30.2998 23.0614 27.7373 26.239 27.7373C29.4165 27.7373 31.9923 30.2998 31.9923 33.4611Z",
    fill: "url(#paint48_radial_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9921 33.4611C31.9921 30.2998 29.4163 27.7373 26.2389 27.7373C24.9352 27.7373 23.733 28.1689 22.7683 28.8959C22.81 28.9539 22.861 29.0047 22.9195 29.0458C22.9615 29.1043 23.0128 29.1558 23.0717 29.1972C23.0801 29.2091 23.0892 29.2205 23.0984 29.2318V30.9603C23.0984 31.1749 23.2053 31.364 23.3688 31.4794L29.844 37.9214C31.1538 36.8723 31.9921 35.2642 31.9921 33.4611Z",
    fill: "url(#paint49_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2939 25.1283C30.2939 27.3562 28.4784 29.1623 26.2389 29.1623C23.9993 29.1623 22.1838 27.3562 22.1838 25.1283C22.1838 22.9004 23.9993 21.0942 26.2389 21.0942C28.4784 21.0942 30.2939 22.9004 30.2939 25.1283Z",
    fill: "url(#paint50_radial_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.2388 21.0942C24.4721 21.0942 22.9696 22.2182 22.4138 23.7866L27.5873 28.9336C29.1638 28.3807 30.2938 26.8859 30.2938 25.1283C30.2938 22.9002 28.4783 21.0942 26.2388 21.0942Z",
    fill: "url(#paint51_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9971 28.6466V30.9603C24.9971 31.312 24.7105 31.5971 24.3568 31.5971H23.7387C23.385 31.5971 23.0984 31.312 23.0984 30.9603V28.6466C23.0984 28.2947 23.385 28.0098 23.7387 28.0098H24.3568C24.7105 28.0098 24.9971 28.2947 24.9971 28.6466Z",
    fill: "url(#paint52_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.994 31.0201C24.9958 31.0003 24.9971 30.9804 24.9971 30.9601V28.6466C24.9971 28.2947 24.7105 28.0098 24.3568 28.0098H23.7387C23.385 28.0098 23.0984 28.2947 23.0984 28.6466V29.1342L24.994 31.0201Z",
    fill: "url(#paint53_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1889 29.1623H23.289C22.9355 29.1623 22.6489 28.8772 22.6489 28.5255V27.9104C22.6489 27.5586 22.9355 27.2734 23.289 27.2734H29.1889C29.5425 27.2734 29.8291 27.5586 29.8291 27.9104V28.5255C29.8291 28.8772 29.5425 29.1623 29.1889 29.1623Z",
    fill: "url(#paint54_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 30.88C26.5597 30.7657 26.4078 30.6938 26.2388 30.6938C25.9162 30.6938 25.6548 30.9539 25.6548 31.2747C25.6548 31.443 25.7272 31.5941 25.842 31.7002L27.0639 32.916C27.1706 33.0302 27.3224 33.1021 27.4916 33.1021C27.8142 33.1021 28.0757 32.842 28.0757 32.5212C28.0757 32.3529 28.0033 32.2018 27.8884 32.0957L26.6663 30.88Z",
    fill: "url(#paint55_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8227 31.2747C26.8227 31.5957 26.5613 31.8558 26.2388 31.8558C25.9162 31.8558 25.6548 31.5957 25.6548 31.2747C25.6548 30.9539 25.9162 30.6938 26.2388 30.6938C26.5613 30.6938 26.8227 30.9539 26.8227 31.2747Z",
    fill: "url(#paint56_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 25.4514C26.5597 25.3371 26.4078 25.2651 26.2388 25.2651C25.9162 25.2651 25.6548 25.5254 25.6548 25.8462C25.6548 26.0145 25.7272 26.1656 25.842 26.2716L27.0639 27.4872C27.1706 27.6015 27.3224 27.6735 27.4916 27.6735C27.8142 27.6735 28.0757 27.4135 28.0757 27.0925C28.0757 26.9244 28.0033 26.7733 27.8884 26.6672L26.6663 25.4514Z",
    fill: "url(#paint57_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8227 25.8465C26.8227 26.1673 26.5613 26.4275 26.2388 26.4275C25.9162 26.4275 25.6548 26.1673 25.6548 25.8465C25.6548 25.5257 25.9162 25.2656 26.2388 25.2656C26.5613 25.2656 26.8227 25.5257 26.8227 25.8465Z",
    fill: "url(#paint58_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.487 24.5904C24.4156 24.514 24.314 24.4658 24.2007 24.4658C23.985 24.4658 23.8101 24.6399 23.8101 24.8546C23.8101 24.9671 23.8584 25.0682 23.9353 25.1393L24.7529 25.9527C24.8244 26.0293 24.926 26.0775 25.0392 26.0775C25.2549 26.0775 25.4299 25.9034 25.4299 25.6887C25.4299 25.576 25.3816 25.4749 25.3047 25.404L24.487 24.5904Z",
    fill: "url(#paint59_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5917 24.8546C24.5917 25.0694 24.4167 25.2434 24.2009 25.2434C23.985 25.2434 23.8101 25.0694 23.8101 24.8546C23.8101 24.6399 23.985 24.4658 24.2009 24.4658C24.4167 24.4658 24.5917 24.6399 24.5917 24.8546Z",
    fill: "url(#paint60_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.2636 24.5904C28.1922 24.514 28.0906 24.4658 27.9773 24.4658C27.7615 24.4658 27.5867 24.6399 27.5867 24.8546C27.5867 24.9671 27.635 25.0682 27.7119 25.1393L28.5296 25.9527C28.601 26.0293 28.7026 26.0775 28.8158 26.0775C29.0315 26.0775 29.2065 25.9034 29.2065 25.6887C29.2065 25.576 29.1582 25.4749 29.0813 25.404L28.2636 24.5904Z",
    fill: "url(#paint61_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3682 24.8546C28.3682 25.0694 28.1932 25.2434 27.9773 25.2434C27.7616 25.2434 27.5867 25.0694 27.5867 24.8546C27.5867 24.6399 27.7616 24.4658 27.9773 24.4658C28.1932 24.4658 28.3682 24.6399 28.3682 24.8546Z",
    fill: "url(#paint62_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 33.178C26.5597 33.0637 26.4078 32.9917 26.2388 32.9917C25.9162 32.9917 25.6548 33.2518 25.6548 33.5726C25.6548 33.7409 25.7272 33.892 25.842 33.998L27.0639 35.2138C27.1706 35.3281 27.3224 35.3999 27.4916 35.3999C27.8142 35.3999 28.0757 35.1399 28.0757 34.8191C28.0757 34.6508 28.0033 34.4998 27.8884 34.3936L26.6663 33.178Z",
    fill: "url(#paint63_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8227 33.5727C26.8227 33.8936 26.5613 34.1536 26.2388 34.1536C25.9162 34.1536 25.6548 33.8936 25.6548 33.5727C25.6548 33.2518 25.9162 32.9917 26.2388 32.9917C26.5613 32.9917 26.8227 33.2518 26.8227 33.5727Z",
    fill: "url(#paint64_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6663 35.4758C26.5597 35.3616 26.4078 35.2896 26.2388 35.2896C25.9162 35.2896 25.6548 35.5498 25.6548 35.8706C25.6548 36.0389 25.7272 36.19 25.842 36.296L27.0639 37.5117C27.1706 37.6261 27.3224 37.6979 27.4916 37.6979C27.8142 37.6979 28.0757 37.4379 28.0757 37.1171C28.0757 36.9488 28.0033 36.7977 27.8884 36.6916L26.6663 35.4758Z",
    fill: "url(#paint65_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8227 35.8704C26.8227 36.1913 26.5613 36.4515 26.2388 36.4515C25.9162 36.4515 25.6548 36.1913 25.6548 35.8704C25.6548 35.5496 25.9162 35.2896 26.2388 35.2896C26.5613 35.2896 26.8227 35.5496 26.8227 35.8704Z",
    fill: "url(#paint66_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.81 19.7864C30.3987 18.5266 29.4262 17.5739 28.2404 17.1047C28.1565 17.0713 27.9403 16.9916 27.6936 16.9361C27.0508 16.7915 26.3775 16.8374 25.7644 17.0779C25.7604 17.0797 25.7566 17.0811 25.7526 17.0827C24.5666 17.5524 23.6164 18.5266 23.2054 19.7864L23.011 20.3819C22.7013 21.331 22.5435 22.3225 22.5435 23.3204H29.8064C29.8064 22.3225 29.6487 21.331 29.339 20.3819L29.1446 19.7864H30.81Z",
    fill: "url(#paint67_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.339 20.3818L29.1446 19.7862H30.7483C30.3274 18.6746 29.439 17.8345 28.3667 17.4103C28.287 17.3785 28.0814 17.3026 27.8468 17.2499C27.2354 17.1125 26.5953 17.156 26.0124 17.3848C26.0087 17.3864 26.005 17.3878 26.0012 17.3893C24.8737 17.8358 23.9701 18.7621 23.5792 19.96L23.3946 20.5263C23.1 21.4286 22.95 22.3714 22.95 23.3202H29.8066C29.8066 22.3224 29.6487 21.3309 29.339 20.3818Z",
    fill: "url(#paint68_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0111 20.3817C22.7014 21.3309 22.5437 22.3224 22.5437 23.3202H29.8066C29.8066 22.3224 29.6488 21.3309 29.3391 20.3817L29.2987 20.2578H23.0515L23.0111 20.3817Z",
    fill: "url(#paint69_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1445 19.7866L29.0279 19.4362C28.8862 19.002 29.2116 18.5566 29.6704 18.5566H29.8105C30.042 18.5566 30.2593 18.6737 30.3815 18.8694C30.3821 18.8704 30.3828 18.8715 30.3834 18.8726C30.559 19.1544 30.7035 19.4603 30.8099 19.7866H29.1445Z",
    fill: "url(#paint70_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6722 23.8351H22.683C22.2859 23.8351 21.9639 23.5147 21.9639 23.1197V22.8184C21.9639 22.4234 22.2859 22.103 22.683 22.103H29.6721C30.0694 22.103 30.3912 22.4234 30.3912 22.8184V23.1197C30.3914 23.5147 30.0694 23.8351 29.6722 23.8351Z",
    fill: "url(#paint71_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9639 23.1069V23.1195C21.9639 23.5145 22.2859 23.8349 22.683 23.8349H29.6721C30.0694 23.8349 30.3912 23.5145 30.3912 23.1195V23.1069H21.9639Z",
    fill: "url(#paint72_linear_1742_80162)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7372 19.7864C31.7372 20.2959 31.3219 20.7088 30.8099 20.7088C30.2978 20.7088 29.8826 20.2959 29.8826 19.7864C29.8826 19.2768 30.2978 18.8638 30.8099 18.8638C31.3219 18.8638 31.7372 19.2768 31.7372 19.7864Z",
    fill: "url(#paint73_radial_1742_80162)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1742_80162",
    x1: 4.99495,
    y1: 30.7999,
    x2: 7.66756,
    y2: 30.7999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#904D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1742_80162",
    x1: 6.42735,
    y1: 35.0564,
    x2: 6.42735,
    y2: 34.1516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1742_80162",
    x1: 6.42738,
    y1: 36.5656,
    x2: 6.42738,
    y2: 37.7923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1742_80162",
    x1: 1.37354,
    y1: 19.6359,
    x2: 11.4807,
    y2: 19.6359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02905D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1742_80162",
    x1: 7.92518,
    y1: 20.3069,
    x2: 11.9673,
    y2: 21.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1742_80162",
    x1: 6.42713,
    y1: 30.5553,
    x2: 6.42713,
    y2: 33.4634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1742_80162",
    x1: -1.20948,
    y1: 18.6847,
    x2: 10.9421,
    y2: 52.0478,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1742_80162",
    x1: 2.45374,
    y1: 17.3507,
    x2: 14.6053,
    y2: 50.7139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1742_80162",
    x1: -0.129225,
    y1: 10.736,
    x2: 12.0224,
    y2: 44.0992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1742_80162",
    x1: 4.23929,
    y1: 11.0458,
    x2: 16.3908,
    y2: 44.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1742_80162",
    x1: 3.0613,
    y1: 8.39348,
    x2: 15.2129,
    y2: 41.7566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1742_80162",
    x1: 3.47581,
    y1: 8.24316,
    x2: 15.6273,
    y2: 41.6063,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1742_80162",
    x1: 4.25639,
    y1: 5.97194,
    x2: 16.4079,
    y2: 39.335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1742_80162",
    x1: 19.6451,
    y1: 30.1115,
    x2: 22.5761,
    y2: 30.1115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#904D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1742_80162",
    x1: 21.2162,
    y1: 34.78,
    x2: 21.2162,
    y2: 33.7878,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1742_80162",
    x1: 21.216,
    y1: 36.4342,
    x2: 21.216,
    y2: 37.7796,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1742_80162",
    x1: 15.6735,
    y1: 17.868,
    x2: 26.7581,
    y2: 17.868,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02905D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1742_80162",
    x1: 22.241,
    y1: 17.7037,
    x2: 17.6944,
    y2: 18.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1742_80162",
    x1: 21.2159,
    y1: 29.8432,
    x2: 21.2159,
    y2: 33.0325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1742_80162",
    x1: 12.841,
    y1: 16.8247,
    x2: 26.1676,
    y2: 53.4139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1742_80162",
    x1: 16.8583,
    y1: 15.3616,
    x2: 30.1849,
    y2: 51.9509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1742_80162",
    x1: 14.0259,
    y1: 8.10711,
    x2: 27.3524,
    y2: 44.6964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1742_80162",
    x1: 18.8165,
    y1: 8.44709,
    x2: 32.1431,
    y2: 45.0363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1742_80162",
    x1: 17.5247,
    y1: 5.53868,
    x2: 30.8513,
    y2: 42.1279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1742_80162",
    x1: 17.9792,
    y1: 5.37295,
    x2: 31.3058,
    y2: 41.9622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1742_80162",
    x1: 18.8353,
    y1: 2.8822,
    x2: 32.1619,
    y2: 39.4715,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1742_80162",
    x1: 19.3044,
    y1: 8.40045,
    x2: 22.5231,
    y2: 9.5708,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1742_80162",
    x1: 3.85766,
    y1: 12.9821,
    x2: 6.57047,
    y2: 13.9685,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1742_80162",
    x1: 12.418,
    y1: 29.7257,
    x2: 15.4938,
    y2: 29.7257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#904D24"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6D3326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1742_80162",
    x1: 14.0662,
    y1: 34.6243,
    x2: 14.0662,
    y2: 33.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1742_80162",
    x1: 14.0662,
    y1: 36.3611,
    x2: 14.0662,
    y2: 37.773,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#433F43",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1742_80162",
    x1: 8.25,
    y1: 16.8776,
    x2: 19.8819,
    y2: 16.8776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#02905D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E5959"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1742_80162",
    x1: 14.0659,
    y1: 29.4444,
    x2: 14.0659,
    y2: 32.7912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_1742_80162",
    x1: 5.27722,
    y1: 15.783,
    x2: 19.2619,
    y2: 54.1791,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_1742_80162",
    x1: 9.49303,
    y1: 14.2476,
    x2: 23.4777,
    y2: 52.6438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_1742_80162",
    x1: 6.52044,
    y1: 6.63509,
    x2: 20.5051,
    y2: 45.0312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_1742_80162",
    x1: 11.5476,
    y1: 6.99215,
    x2: 25.5324,
    y2: 45.3883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_1742_80162",
    x1: 10.1923,
    y1: 3.93939,
    x2: 24.1769,
    y2: 42.3356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_1742_80162",
    x1: 10.6691,
    y1: 3.76597,
    x2: 24.6538,
    y2: 42.1622,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_1742_80162",
    x1: 11.5675,
    y1: 1.15216,
    x2: 25.5522,
    y2: 39.5483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#384949",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#384949"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_1742_80162",
    x1: 11.9387,
    y1: 9.29873,
    x2: 16.4884,
    y2: 9.65179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_1742_80162",
    x1: 7.831,
    y1: 32.3921,
    x2: 9.50072,
    y2: 34.0764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_1742_80162",
    x1: 15.7586,
    y1: 17.9708,
    x2: 16.7102,
    y2: 18.9307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_1742_80162",
    x1: 5.67578,
    y1: 0.635882,
    x2: 6.62741,
    y2: 1.59574,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_1742_80162",
    x1: 1.43335,
    y1: 15.9537,
    x2: 2.38498,
    y2: 16.9136,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_1742_80162",
    x1: 3.32907,
    y1: 26.9716,
    x2: 4.76123,
    y2: 28.4163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_1742_80162",
    x1: 18.7102,
    y1: 35.8219,
    x2: 18.8265,
    y2: 38.0057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EAF9FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B3DAFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_1742_80162",
    x1: 18.792,
    y1: 36.6741,
    x2: 18.792,
    y2: 37.9615,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3DAFE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2438,
    stopColor: "#ACD5FA",
    stopOpacity: 0.244
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.589,
    stopColor: "#9AC5F0",
    stopOpacity: 0.589
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9932,
    stopColor: "#7CACDF",
    stopOpacity: 0.993
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BACDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1742_80162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0386 26.9097) scale(11.4102 11.3513)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6819,
    stopColor: "#E2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8506,
    stopColor: "#D5EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#C3E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_1742_80162",
    x1: 29.7981,
    y1: 34.2153,
    x2: 22.1913,
    y2: 24.3945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1742_80162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3534 22.6872) scale(7.12363 7.08691)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4615,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6819,
    stopColor: "#E2F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8506,
    stopColor: "#D5EBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.993,
    stopColor: "#C3E1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_1742_80162",
    x1: 26.6572,
    y1: 25.9604,
    x2: 25.8029,
    y2: 21.1698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_1742_80162",
    x1: 22.9639,
    y1: 29.2174,
    x2: 26.6333,
    y2: 31.2221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#A9C93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB437"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_1742_80162",
    x1: 24.9611,
    y1: 30.7771,
    x2: 23.49,
    y2: 27.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#8DB437",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4813,
    stopColor: "#698927",
    stopOpacity: 0.478431
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#455F18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_1742_80162",
    x1: 26.2003,
    y1: 27.2948,
    x2: 26.2827,
    y2: 29.2814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D3E843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#A9C93C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DB437"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_1742_80162",
    x1: 27.2917,
    y1: 32.3222,
    x2: 25.4397,
    y2: 30.4606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_1742_80162",
    x1: 25.7265,
    y1: 30.6708,
    x2: 26.5005,
    y2: 31.5928,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_1742_80162",
    x1: 27.2917,
    y1: 26.8937,
    x2: 25.4397,
    y2: 25.0321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_1742_80162",
    x1: 25.7265,
    y1: 25.2425,
    x2: 26.5005,
    y2: 26.1646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD459"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1917,
    stopColor: "#FFD254"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4166,
    stopColor: "#FFCD46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6583,
    stopColor: "#FFC52E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9103,
    stopColor: "#FFB90E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_1742_80162",
    x1: 24.9054,
    y1: 25.5555,
    x2: 23.6661,
    y2: 24.3098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_1742_80162",
    x1: 23.8582,
    y1: 24.4504,
    x2: 24.3761,
    y2: 25.0674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_1742_80162",
    x1: 28.682,
    y1: 25.5555,
    x2: 27.4427,
    y2: 24.3098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_1742_80162",
    x1: 27.6346,
    y1: 24.4504,
    x2: 28.1525,
    y2: 25.0674,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_1742_80162",
    x1: 27.2917,
    y1: 34.6202,
    x2: 25.4397,
    y2: 32.7586,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1742_80162",
    x1: 25.7265,
    y1: 32.9687,
    x2: 26.5005,
    y2: 33.8907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1742_80162",
    x1: 27.2917,
    y1: 36.9181,
    x2: 25.4397,
    y2: 35.0565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1742_80162",
    x1: 25.7265,
    y1: 35.2665,
    x2: 26.5005,
    y2: 36.1885,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45425A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D3251"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1742_80162",
    x1: 23.878,
    y1: 18.4446,
    x2: 29.2648,
    y2: 23.8593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF706A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8111,
    stopColor: "#F64640"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F43B36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1742_80162",
    x1: 26.7959,
    y1: 21.3823,
    x2: 23.8065,
    y2: 16.8498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF706A",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4151,
    stopColor: "#FF726C",
    stopOpacity: 0.415686
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5646,
    stopColor: "#FF7873",
    stopOpacity: 0.564706
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6712,
    stopColor: "#FF847E",
    stopOpacity: 0.670588
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7574,
    stopColor: "#FF948F",
    stopOpacity: 0.756863
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8313,
    stopColor: "#FFA9A5",
    stopOpacity: 0.831373
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8966,
    stopColor: "#FFC3C1",
    stopOpacity: 0.898039
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9543,
    stopColor: "#FFE1E0",
    stopOpacity: 0.952941
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1742_80162",
    x1: 26.1751,
    y1: 21.4502,
    x2: 26.1751,
    y2: 22.9689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43B36",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#D02021",
    stopOpacity: 0.435294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1742_80162",
    x1: 29.9307,
    y1: 19.2636,
    x2: 28.7848,
    y2: 19.6941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F43B36",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.436,
    stopColor: "#D02021",
    stopOpacity: 0.435294
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A60108"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1742_80162",
    x1: 26.0808,
    y1: 22.6254,
    x2: 26.5431,
    y2: 24.2833,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1742_80162",
    x1: 26.1776,
    y1: 23.245,
    x2: 26.1776,
    y2: 24.2179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0029,
    stopColor: "#C2E0FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0763,
    stopColor: "#BFDCFD",
    stopOpacity: 0.07451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EB2E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_1742_80162",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.1349 18.9141) scale(1.67861 1.66996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5353,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7282,
    stopColor: "#E3F2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8651,
    stopColor: "#D8ECFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9756,
    stopColor: "#C7E3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C2E0FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1742_80162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.1765,
    height: 21.0673,
    fill: "white",
    transform: "translate(15.6155 16.854)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMembershipAdIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/membershipAdIcon.d00ba494520faf10b3811dc845ec886a.svg";